import { useEffect, useState } from "react";
import {
  Box,
  Button,
  Flex,
  Heading,
  Select,
  Text,
  useDisclosure,
} from "@chakra-ui/react";
import { crm } from "../../theme";
import { useNavigate } from "react-router-dom";
import { useMediaQuery } from "react-responsive";
import { FaPlus } from "react-icons/fa";
import useAuthUser from "react-auth-kit/hooks/useAuthUser";
import Layout from "../../components/Layout";
import Filter from "../../components/Filter";
import { Tag } from "../../models/Filter";
import ProspectItem from "./components/prospectItem";
import { getProspects } from "../../services/prospectService";
import CreateProspectModal from "./components/CreateProspectModal";

const Prospects = () => {
  const isMobile = useMediaQuery({ query: "(max-width: 768px)" });
  const auth = useAuthUser<any>();
  const navigate = useNavigate();
  const [tags, setTags] = useState<Tag[]>([]);
  const [status, setStatus] = useState(false);
  const [loading, setLoading] = useState(false);
  const [prospects, setProspects] = useState([]);
  useEffect(() => {
    if (!auth?.admin) navigate("/");
  }, [auth]);
  const get = async () => {
    setLoading(true);

    const response = await getProspects({
      status,
      client: tags
        .filter((t) => t.type === "client")
        ?.map((t) => t.value)
        .join("|"),
    });
    setProspects(response);
    setTimeout(() => {
      setLoading(false);
    }, 200);
    return response;
  };
  useEffect(() => {
    get();
  }, [tags]);
  const { isOpen, onOpen, onClose } = useDisclosure();

  return (
    <Box height={isMobile ? undefined : "100vh"} overflow="hidden">
      <Layout>
        <Box
          overflowY="hidden"
          padding="8px"
          backgroundColor="var(--main-bg-color)"
        >
          <Flex alignItems="center" justifyContent="center" flexDir="column">
            <Flex width="90%" mt="48px" mb="24px" align="center" gap="12px">
              <Box w="4px" h="34px" bg={crm.brand} borderRadius="full" />
              <Box>
                <Text fontSize="28px" fontWeight="700" color={crm.text} lineHeight="1.1">Clientes</Text>
                <Text color={crm.textMuted} fontSize="sm" mt="2px">Gerencie seus prospects e oportunidades.</Text>
              </Box>
            </Flex>

            <Flex
              backgroundColor={crm.surface}
              border={`1px solid ${crm.border}`}
              boxShadow={crm.shadowSm}
              borderRadius={crm.radius}
              width="90%"
              p="32px"
              mb="48px"
            >
              <Filter
                types={[
                  { label: "Pesquisar por nome do prospect", type: "name" },
                ]}
                extraFilters={[
                  <Box>
                    <Heading size="sm" mb="8px">
                      Status
                    </Heading>
                    <Select
                      w={{ base: "100%", md: "16vw" }}
                      backgroundColor="white"
                    >
                      <option>Pendente</option>
                      <option>Ativo</option>
                      <option>Inativo</option>
                    </Select>
                  </Box>,
                ]}
                {...{
                  tags,
                  setTags,
                }}
              />
            </Flex>
            <Flex w="90%" justifyContent="flex-end" mb="24px">
              <Button
                color="white"
                borderRadius="10px"
                backgroundColor="var(--icon-color)"
                _hover={{ backgroundColor: crm.brandDark }}
                onClick={onOpen}
              >
                <Flex justifyContent="center" alignItems="center" gap="8px">
                  <FaPlus color="white" /> Adicionar Prospect
                </Flex>
              </Button>
            </Flex>
            <CreateProspectModal {...{ get, isOpen, onClose }} />
            <Flex
              flexDir="column"
              alignItems="center"
              w="95%"
              pb="32px"
              gap="32px"
              justifyContent="center"
              background="var(main-bg-color)"
            >
              {Array.from({ length: Math.ceil(prospects?.length / 10) })?.map(
                (_, blockIndex) => (
                  <Box
                    key={blockIndex}
                    backgroundColor={crm.surface}
                    p="24px"
                    borderRadius={crm.radius}
                    border={`1px solid ${crm.border}`}
                    boxShadow={crm.shadowSm}
                    overflow="hidden"
                  >
                    <Flex gap="24px" flexWrap="wrap">
                      {prospects
                        ?.slice(blockIndex * 10, (blockIndex + 1) * 10)
                        ?.map((p, idx) => (
                          <ProspectItem get={get} key={idx} p={p} />
                        ))}
                    </Flex>
                  </Box>
                )
              )}
            </Flex>
          </Flex>
        </Box>
      </Layout>
    </Box>
  );
};
export default Prospects;
